<template>
  <header class="site-header">
    <div class="container header-content">
      <div class="logo" @click="$router.push('/')">
        <span class="logo-mark">政经事</span>
        <span class="logo-sub">Roadlink GLB</span>
      </div>

      <!-- 汉堡菜单（移动端） -->
      <div class="mobile-menu" @click="toggleMobileMenu">
        <span></span><span></span><span></span>
      </div>

      <nav :class="{ show: mobileMenuOpen }">
        <ul>
          <li v-for="item in navItems" :key="item.id">
            <a
              v-if="item.external"
              :href="item.url"
              target="_blank"
              rel="noopener"
              @click="closeMobileMenu"
            >
              {{ item.text }}
            </a>
            <router-link
              v-else
              :to="item.path"
              :class="{ active: $route.name === item.name }"
              @click.native="closeMobileMenu"
            >
              {{ item.text }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data () {
    return {
      mobileMenuOpen: false,
      navItems: [
        { id: 'home', text: '首页', path: '/', name: 'Home' },
        { id: 'countries', text: '国家资讯', path: '/countries', name: 'CountryList' },
        { id: 'business', text: '商务活动', path: '/business', name: 'BusinessList' },
        { id: 'oversea', text: '出海服务', path: '/oversea-service', name: 'OverseaService' },
        { id: 'venue', text: '场地预定', external: true, url: 'https://crm.roadlinkglb.com/html/rongchaoyuding/index.html' },
        { id: 'about', text: '关于我们', path: '/about', name: 'About' }
      ]
    }
  },
  methods: {
    toggleMobileMenu () {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu () {
      this.mobileMenuOpen = false
    }
  },
  watch: {
    $route () {
      this.closeMobileMenu()
    }
  }
}
</script>

<style scoped>
.site-header {
  background: #ffffff;
  padding: 14px 0;
  box-shadow: 0 2px 12px rgba(36, 68, 203, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: baseline;
  cursor: pointer;
  user-select: none;
}

.logo-mark {
  font-size: 22px;
  font-weight: 800;
  color: #2444cb;
  letter-spacing: 1px;
}

.logo-sub {
  font-size: 13px;
  font-weight: 600;
  color: #8aa0d6;
  margin-left: 8px;
}

nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

nav li {
  margin-left: 18px;
}

nav a {
  color: #303030;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  padding: 8px 18px;
  border-radius: 20px;
  transition: all 0.3s ease;
  display: block;
}

nav a:hover,
nav a.active {
  background-color: #2444cb;
  color: #fff;
}

.mobile-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 18px;
  cursor: pointer;
}

.mobile-menu span {
  display: block;
  height: 2px;
  width: 100%;
  background-color: #2444cb;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .mobile-menu {
    display: flex;
  }
  nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    display: none;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    border-top: 1px solid #eef1f8;
  }
  nav.show {
    display: block;
  }
  nav ul {
    flex-direction: column;
    padding: 8px 0;
  }
  nav li {
    margin: 0;
  }
  nav a {
    border-radius: 0;
    padding: 14px 20px;
  }
}
</style>
